// 検索フォーム処理 - カート機能に影響を与えないよう修正
(function() {
  // 商品詳細ページでは実行しない
  if (document.querySelector('.template-product')) {
    return;
  }
  
  // 検索フォームとボタンを処理する関数
  function handleSearchElements() {
    // 検索フォームのみを対象とする
    document.querySelectorAll('form.search-form, form.search-bar__form, form[action*="/search"], form[action*="search-results"]').forEach(form => {
      // カート追加フォームは除外
      if (form.closest('[data-product-form]') || 
          (form.getAttribute('action') && form.getAttribute('action').includes('/cart/add'))) {
        return;
      }
      
      // すでに処理済みのフォームはスキップ
      if (form.hasAttribute('data-fixed-search-form')) return;
      
      // ブログ検索の特徴をチェック
      const isBlogSearch = 
        form.querySelector('input[placeholder*="ブログ"]') ||
        form.querySelector('input[name="type"][value="article"]') ||
        (window.location.pathname.includes('/blogs/') || window.location.pathname.includes('/news'));
      
      // 処理済みマークを付ける
      form.setAttribute('data-fixed-search-form', 'true');
      
      // フォームの送信先を設定
      form.setAttribute('action', '/search');
      
      // 商品検索用のhidden inputを確保
      if (!isBlogSearch) {
        let typeInput = form.querySelector('input[name="type"]');
        if (!typeInput) {
          typeInput = document.createElement('input');
          typeInput.type = 'hidden';
          typeInput.name = 'type';
          form.appendChild(typeInput);
        }
        typeInput.value = 'product';
      }
      
      // フォーム送信をインターセプト
      form.addEventListener('submit', function(e) {
        const input = this.querySelector('input[name="q"]');
        if (!input || !input.value) return;
        
        // デフォルトの送信を使用する（イベント伝播を止めない）
        // カート追加機能に影響を与えないよう、preventDefault()は使わない
        // e.preventDefault();
        
        // 検索フォームが正しく設定されていれば、追加処理は不要
      });
    });
  }
  
  // DOMContentLoaded時に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleSearchElements);
  } else {
    handleSearchElements();
  }
  
  // DOM変更を監視（ヘッダーが動的に読み込まれる場合など）
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      // 新しい検索フォームが追加された場合にのみ実行
      const hasNewSearchForms = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 && (
            node.classList && (
              node.classList.contains('search-form') || 
              node.classList.contains('search-bar__form')
            ) ||
            node.querySelector && (
              node.querySelector('form.search-form') || 
              node.querySelector('form.search-bar__form')
            )
          );
        });
      });
      
      if (hasNewSearchForms) {
        handleSearchElements();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();